import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { iconTypes } from '../icon/icon.constants';

export interface SelectItem {
  label: string;
  value: string;
}

@Component({
  standalone: false,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {

  @Input() items: SelectItem[];
  @Input() placeholder: string = '';
  @Output() onChange = new EventEmitter<SelectItem | null>();

  selectedItem: SelectItem | null = null;
  isCollapsed = true;
  iconType = iconTypes.caretDown;

  constructor(private elementRef: ElementRef) { }

  trackByFn(index: number, item: SelectItem) {
    return item.label;
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.updateIcon();
  }

  updateIcon() {
    this.iconType = this.isCollapsed ? iconTypes.caretDown : iconTypes.caretUp;
  }

  selectItem(item: SelectItem) {
    this.selectedItem = item;
    this.onChange.emit(item);
    this.isCollapsed = true;
    this.updateIcon();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isCollapsed = true;
      this.updateIcon();
    }
  }

}
